/* template */
<template><es-popup :show="(show)" :position="(position)" @close="close" :class='[$attrs["custom-class"]]' v-if="(show)"><div class="drawer-container"><slot name="header"></slot><div class="drawer-main custom-main"><slot/></div></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m06b5b816"}'>
.drawer-container 
  width 100vw
  max-height 80vh
  background #ffffff
  border-radius 16px 16px 0 0
  overflow hidden

.drawer-main 
  padding 0 12px
  overflow auto
  max-height calc(80vh - 60px)

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m06b5b816"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex06b5b816%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex06b5b816%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m06b5b816"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index06b5b816/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-navbar':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/navbar/index.mpx?isComponent&outputPath=components%2Findex15de91ba%2Findex")),'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
